import { Box, Button, Card, CardHeader, CardBody, Heading, Text, VStack } from '@chakra-ui/react'
import { useNavigate, useParams, useSearchParams, useLocation } from 'react-router-dom'
import { AdminLayout } from '@/components/layout/AdminLayout'
import { StatementOfAccountForm } from '@/components/forms/StatementOfAccountForm'
import { useThemeColors } from '@/hooks/useThemeColors'
import { shippingLineNameFromSearchParams } from '@/lib/navigation/financialStatementsSearchParams'

type CreateSoaLocationState = {
  selectedBookingIds?: number[]
} | null

export default function CreateSoaPage() {
  const colors = useThemeColors()
  const navigate = useNavigate()
  const location = useLocation()
  const [searchParams] = useSearchParams()
  const paramsShippingLineId = useParams<{ shippingLineId: string }>().shippingLineId

  const selectedBookingIds =
    (location.state as CreateSoaLocationState)?.selectedBookingIds ?? []
  const shippingLineName = shippingLineNameFromSearchParams(searchParams)
  const finalShippingLineId = paramsShippingLineId
  const handleSuccess = () => {
    if (finalShippingLineId) navigate(`/shipping-lines/financial-statements/${finalShippingLineId}`)
    else navigate('/shipping-lines')
  }

  const handleCancel = () => {
    if (finalShippingLineId) navigate(`/shipping-lines/financial-statements/${finalShippingLineId}`)
    else navigate('/shipping-lines')
  }

  if (!finalShippingLineId) {
    return (
      <AdminLayout constrainedContent>
        <Box p={4}>
          <Text color={colors.textSecondary} mb={4}>
            Missing shipping line. Please go back and select a shipping line.
          </Text>
          <Button size="sm" variant="outline" onClick={() => navigate('/shipping-lines')}>
            Back to Shipping Lines
          </Button>
        </Box>
      </AdminLayout>
    )
  }

  return (
    <AdminLayout constrainedContent>
      <Box
        p={4}
        minW={0}
        h="100%"
        overflow="auto"
        display="flex"
        flexDirection="column"
      >
        <VStack spacing={0} align="stretch" flex="1" minH={0} minW={0}>
          <Card minW={0}>
            <CardHeader>
              <Heading size="md" mb={1}>
                Create Statement of Account
              </Heading>
              <Text fontSize="sm" color={colors.text}>
                Create a new Statement of Account
              </Text>
            </CardHeader>
            <CardBody minW={0} overflow="visible">
              <StatementOfAccountForm
                shippingLineId={finalShippingLineId}
                shippingLineName={shippingLineName}
                selectedBookingIds={selectedBookingIds}
                onSuccess={handleSuccess}
                onCancel={handleCancel}
              />
            </CardBody>
          </Card>
        </VStack>
      </Box>
    </AdminLayout>
  )
}
